import catalogueModalHtml from './catalogue-modal.js';
import initSearch from './search.js';

const initPageTransitions = () => {

    if (!document.getElementById('page-loader')) {
        const loader = document.createElement('div');
        loader.id = 'page-loader';
        document.body.appendChild(loader);
    }

    const loader = document.getElementById('page-loader');


    document.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (
            link &&
            link.href &&
            link.href.startsWith(window.location.origin) &&
            !link.getAttribute('target') &&
            !link.getAttribute('download') &&
            !link.href.includes('#')
        ) {
            e.preventDefault();
            const targetUrl = link.href;


            loader.classList.add('animate');

            setTimeout(() => {
                window.location.href = targetUrl;
            }, 300);
        }
    });


    window.addEventListener('pageshow', (event) => {
        if (event.persisted && loader) {
            loader.classList.remove('animate');
        }
    });
};


// Popup asking for details + an email verification code. download.html has the markup
// in the page; other pages with catalogue buttons get it added on first use.
// Calls onVerified(link) once the server has unlocked the catalogues.
const createCatalogueGate = (onVerified) => {
    if (!document.getElementById('catalogue-modal')) {
        document.body.insertAdjacentHTML('beforeend', catalogueModalHtml);
        if (window.lucide) window.lucide.createIcons();
    }

    const modal = document.getElementById('catalogue-modal');
    const form = document.getElementById('catalogue-form');
    const sendBtn = document.getElementById('catalogue-send-code');
    const submitBtn = document.getElementById('catalogue-submit');
    const submitLabel = document.getElementById('catalogue-submit-label');
    const codeInput = document.getElementById('catalogue-code');
    const statusEl = document.getElementById('catalogue-status');
    const selectedEl = document.getElementById('catalogue-selected');
    const sendLabel = sendBtn.textContent.trim();
    const submitText = submitLabel.textContent.trim();

    let pendingLink = null;
    let codeSentTo = '';
    let cooldownTimer = null;
    let busy = false;

    const STATUS_STYLES = {
        error: ['bg-red-50', 'border-red-200', 'text-red-700'],
        success: ['bg-primary-light', 'border-primary/20', 'text-primary-dark'],
    };

    const setStatus = (message, type = 'success') => {
        statusEl.textContent = message || '';
        statusEl.classList.toggle('hidden', !message);
        Object.entries(STATUS_STYLES).forEach(([key, classes]) => {
            classes.forEach((c) => statusEl.classList.toggle(c, key === type));
        });
    };

    const updateSubmit = () => {
        submitBtn.disabled = busy || !codeSentTo || !/^\d{6}$/.test(codeInput.value);
    };

    const resetCode = () => {
        codeSentTo = '';
        codeInput.value = '';
        codeInput.disabled = true;
        updateSubmit();
    };

    const startCooldown = (seconds) => {
        clearInterval(cooldownTimer);
        let left = seconds;
        sendBtn.disabled = true;
        const tick = () => {
            if (left <= 0) {
                clearInterval(cooldownTimer);
                sendBtn.disabled = false;
                sendBtn.textContent = codeSentTo ? 'Resend Code' : sendLabel;
                return;
            }
            sendBtn.textContent = `Resend in ${left}s`;
            left -= 1;
        };
        tick();
        cooldownTimer = setInterval(tick, 1000);
    };

    const catalogueName = (link) => {
        const card = link && link.closest('.product-card');
        const title = card && card.querySelector('h4');
        return title ? title.textContent.trim() : (link ? `${link.dataset.catalogue}.pdf` : '');
    };

    const openModal = (link) => {
        pendingLink = link;
        const name = catalogueName(link);
        selectedEl.textContent = name ? `Selected: ${name}` : '';
        selectedEl.classList.toggle('hidden', !name);
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        document.body.style.overflow = 'hidden';
        setTimeout(() => form.elements.name.focus(), 50);
    };

    const closeModal = () => {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        document.body.style.overflow = '';
    };

    // POSTs to a PHP endpoint and always resolves to { ok, status, message, ... }
    const post = async (url, body) => {
        let response;
        try {
            response = await fetch(url, { method: 'POST', body, credentials: 'same-origin' });
        } catch (e) {
            return { ok: false, status: 0, message: 'Network error. Please check your connection and try again.' };
        }
        try {
            const data = await response.json();
            return { ...data, status: response.status };
        } catch (e) {
            console.error(`${url} returned HTTP ${response.status} without JSON. Is PHP running on this server?`);
            const message = response.status === 404
                ? 'The verification service could not be reached. Please try again later.'
                : `Server error (${response.status}). Please try again later.`;
            return { ok: false, status: response.status, message };
        }
    };

    const validFields = () => {
        const fields = ['name', 'phone', 'email', 'company'].map((n) => form.elements[n]);
        const invalid = fields.find((f) => !f.value.trim() || !f.checkValidity());
        if (invalid) {
            setStatus('Please fill in all the fields with valid details.', 'error');
            invalid.focus();
            return false;
        }
        if (!/^\+?[0-9 ()-]{7,20}$/.test(form.elements.phone.value.trim())) {
            setStatus('Please enter a valid phone number.', 'error');
            form.elements.phone.focus();
            return false;
        }
        return true;
    };

    modal.addEventListener('click', (e) => {
        if (e.target === modal || e.target.closest('[data-catalogue-close]')) closeModal();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeModal();
    });

    // A code only works for the address it was sent to
    form.elements.email.addEventListener('input', () => {
        if (codeSentTo && form.elements.email.value.trim().toLowerCase() !== codeSentTo) {
            resetCode();
            setStatus('Email changed. Please request a new code.', 'error');
        }
    });

    codeInput.addEventListener('input', () => {
        codeInput.value = codeInput.value.replace(/\D/g, '').slice(0, 6);
        updateSubmit();
    });

    sendBtn.addEventListener('click', async () => {
        if (!validFields()) return;

        sendBtn.disabled = true;
        sendBtn.textContent = 'Sending...';
        setStatus('');

        const data = await post('/api/send-code.php', new FormData(form));
        if (data.ok) {
            codeSentTo = form.elements.email.value.trim().toLowerCase();
            codeInput.disabled = false;
            codeInput.focus();
            setStatus(`${data.message} Enter it above to unlock the download.`);
            startCooldown(data.cooldown || 60);
        } else {
            setStatus(data.message, 'error');
            if (data.retry_after) {
                startCooldown(data.retry_after);
            } else {
                sendBtn.disabled = false;
                sendBtn.textContent = codeSentTo ? 'Resend Code' : sendLabel;
            }
        }
        updateSubmit();
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (submitBtn.disabled || !validFields()) return;

        const formData = new FormData(form);
        formData.append('catalogue', catalogueName(pendingLink));
        formData.append('page', window.location.href);

        busy = true;
        updateSubmit();
        submitLabel.textContent = 'Verifying...';

        const data = await post('/api/verify-code.php', formData);
        if (data.ok) {
            setStatus(data.message);
            closeModal();
            if (pendingLink) onVerified(pendingLink);
            pendingLink = null;
        } else {
            setStatus(data.message, 'error');
            // Expired, locked out or no code on the server: a new code is needed
            if ([400, 410, 429].includes(data.status)) resetCode();
        }

        busy = false;
        submitLabel.textContent = submitText;
        updateSubmit();
    });

    return { open: openModal };
};


// Catalogue buttons carry data-catalogue="<file id>" instead of a PDF path. Clicking one
// opens the verification popup; once verified, the PDF is fetched from /api/catalogue.php,
// which only serves it to visitors with the server's signed access cookie.
const initCatalogueDownloads = () => {
    // Remembers that this browser verified, so the popup is skipped next time.
    // Only a hint for the UI: the server still checks its own cookie on every download.
    const VERIFIED_KEY = 'cpCatalogueVerified';
    let gate = null;

    const isVerified = () => {
        try { return localStorage.getItem(VERIFIED_KEY) === '1'; } catch (e) { return false; }
    };

    const setVerified = (on) => {
        try {
            if (on) localStorage.setItem(VERIFIED_KEY, '1');
            else localStorage.removeItem(VERIFIED_KEY);
        } catch (e) { /* private mode */ }
    };

    const openGate = (link) => {
        gate = gate || createCatalogueGate((verifiedLink) => {
            setVerified(true);
            start(verifiedLink, true);
        });
        gate.open(link);
    };

    const setLoading = (on) => {
        const loader = document.getElementById('page-loader');
        if (!loader) return;
        if (on) loader.classList.add('animate');
        else setTimeout(() => loader.classList.remove('animate'), 500);
    };

    const catalogueUrl = (id, dl = false) => `/api/catalogue.php?id=${encodeURIComponent(id)}${dl ? '&dl=1' : ''}`;

    // Resolves to 'ok', 'locked' (not verified yet) or 'error'
    const checkAccess = async (id) => {
        setLoading(true);
        try {
            const response = await fetch(catalogueUrl(id), { method: 'HEAD', credentials: 'same-origin', cache: 'no-store' });
            if (response.status === 403) return 'locked';
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return 'ok';
        } catch (error) {
            console.error(`Catalogue check failed (${id}):`, error);
            return 'error';
        } finally {
            setLoading(false);
        }
    };

    // Full-screen viewer: shows the PDF in the browser's own viewer, with a Download button.
    // Phones and browsers without a built-in PDF viewer get "Open" / "Download" buttons instead.
    let viewer = null;
    const getViewer = () => {
        if (viewer) return viewer;
        document.body.insertAdjacentHTML('beforeend', `
<div id="catalogue-viewer" class="fixed inset-0 z-[210] hidden flex-col bg-[#0f172a]/80 backdrop-blur-sm p-0 md:p-6"
    role="dialog" aria-modal="true" aria-labelledby="catalogue-viewer-title">
    <div class="flex flex-col w-full max-w-6xl h-full mx-auto bg-white md:rounded-xl overflow-hidden shadow-2xl">
        <div class="flex items-center gap-3 px-4 md:px-6 py-3 border-b border-slate-100">
            <i data-lucide="file-text" class="w-5 h-5 text-primary shrink-0"></i>
            <h2 id="catalogue-viewer-title" class="flex-1 min-w-0 truncate text-[15px] md:text-[17px] font-semibold text-[#1a1a1a]"></h2>
            <a id="catalogue-viewer-download" download
                class="flex items-center gap-2 bg-primary text-white font-bold text-[12px] tracking-wider uppercase px-4 py-2.5 rounded-md hover:bg-primary-dark transition-colors shrink-0">
                <i data-lucide="download" class="w-4 h-4"></i>
                <span class="hidden sm:inline">Download</span>
            </a>
            <button type="button" data-viewer-close aria-label="Close"
                class="p-2 rounded-full text-[#718096] hover:text-[#1a1a1a] hover:bg-slate-100 transition-colors shrink-0">
                <i data-lucide="x" class="w-5 h-5"></i>
            </button>
        </div>
        <iframe id="catalogue-viewer-frame" title="Catalogue preview" class="hidden flex-1 w-full bg-slate-100"></iframe>
        <div id="catalogue-viewer-fallback" class="hidden flex-1 flex-col items-center justify-center gap-6 px-6 text-center">
            <div class="w-16 h-16 rounded-full bg-primary-light flex items-center justify-center">
                <i data-lucide="file-text" class="w-8 h-8 text-primary"></i>
            </div>
            <p class="text-[#4A5568] text-[15px] max-w-sm">Your catalogue is ready. Open it to view, or download a copy.</p>
            <div class="flex flex-col sm:flex-row gap-3 w-full max-w-sm">
                <a id="catalogue-viewer-open" target="_blank" rel="noopener"
                    class="flex-1 bg-primary text-white font-bold text-[12px] tracking-wider uppercase px-6 py-4 rounded-md text-center hover:bg-primary-dark transition-colors">
                    View Catalogue
                </a>
                <a id="catalogue-viewer-download-alt" download
                    class="flex-1 border border-primary text-primary font-bold text-[12px] tracking-wider uppercase px-6 py-4 rounded-md text-center hover:bg-primary hover:text-white transition-colors">
                    Download
                </a>
            </div>
        </div>
    </div>
</div>`);
        if (window.lucide) window.lucide.createIcons();

        const el = document.getElementById('catalogue-viewer');
        const frame = document.getElementById('catalogue-viewer-frame');
        const fallback = document.getElementById('catalogue-viewer-fallback');
        const close = () => {
            el.classList.add('hidden');
            el.classList.remove('flex');
            frame.removeAttribute('src');
            document.body.style.overflow = '';
        };
        el.addEventListener('click', (e) => {
            if (e.target === el || e.target.closest('[data-viewer-close]')) close();
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !el.classList.contains('hidden')) close();
        });

        const canEmbedPdf = () => navigator.pdfViewerEnabled === true && window.matchMedia('(min-width: 768px)').matches;

        viewer = {
            open: (id, name) => {
                document.getElementById('catalogue-viewer-title').textContent = name || `${id}.pdf`;
                document.getElementById('catalogue-viewer-download').href = catalogueUrl(id, true);
                document.getElementById('catalogue-viewer-download-alt').href = catalogueUrl(id, true);
                document.getElementById('catalogue-viewer-open').href = catalogueUrl(id);
                const embed = canEmbedPdf();
                frame.classList.toggle('hidden', !embed);
                fallback.classList.toggle('hidden', embed);
                fallback.classList.toggle('flex', !embed);
                if (embed) frame.src = catalogueUrl(id);
                el.classList.remove('hidden');
                el.classList.add('flex');
                document.body.style.overflow = 'hidden';
            },
        };
        return viewer;
    };

    const catalogueTitle = (link) => {
        const card = link.closest('.product-card');
        const title = card && card.querySelector('h4');
        return title ? title.textContent.trim() : '';
    };

    const start = async (link, justVerified = false) => {
        if (!justVerified && !isVerified()) {
            openGate(link);
            return;
        }
        const id = link.dataset.catalogue;
        const result = await checkAccess(id);
        if (result === 'ok') {
            getViewer().open(id, catalogueTitle(link));
        } else if (result === 'locked' && !justVerified) {
            // Access expired or cookie cleared: verify again
            setVerified(false);
            openGate(link);
        } else if (result === 'locked') {
            alert('Your email is verified, but the catalogue was blocked. Please allow cookies for this site and try again.');
        } else {
            alert('Sorry, the catalogue could not be opened right now. Please try again later.');
        }
    };

    document.addEventListener('click', (e) => {
        const link = e.target.closest('[data-catalogue]');
        if (!link) return;
        e.preventDefault();
        start(link);
    });
};


const initIcons = () => {
    if (window.lucide) {
        window.lucide.createIcons();
    }
};


const initSwiper = () => {
    const swiperEl = document.querySelector(".mySwiper");
    if (swiperEl && window.Swiper) {
        new window.Swiper(".mySwiper", {
            slidesPerView: 1.1,
            spaceBetween: 20,
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.2,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                }
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            grabCursor: true,
        });
    }
};


const initHeaderScroll = () => {
    window.addEventListener('scroll', () => {
        const header = document.querySelector('header');
        if (header) {
            if (window.scrollY > 50) {
                header.classList.add('py-2');
                header.classList.remove('py-4');
            } else {
                header.classList.add('py-4');
                header.classList.remove('py-2');
            }
        }
    });
};


const initMobileMenu = () => {
    const toggleBtn = document.getElementById('mobile-menu-toggle');
    const closeBtn = document.getElementById('mobile-menu-close');
    const menu = document.getElementById('mobile-menu');
    const menuLinks = document.querySelectorAll('#mobile-menu a');
    const mobileProductsToggle = document.getElementById('mobile-products-toggle');
    const mobileProductsMenu = document.getElementById('mobile-products-menu');

    // Handle mobile menu open/close
    if (toggleBtn && menu) {
        toggleBtn.addEventListener('click', () => {
            menu.classList.remove('translate-x-full');
            document.body.style.overflow = 'hidden';
        });
    }

    if (closeBtn && menu) {
        closeBtn.addEventListener('click', () => {
            menu.classList.add('translate-x-full');
            document.body.style.overflow = '';
        });
    }

    // Close menu when any link is clicked
    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            menu.classList.add('translate-x-full');
            document.body.style.overflow = '';
        });
    });

    // Handle mobile products submenu toggle
    if (mobileProductsToggle && mobileProductsMenu) {
        const productsChevron = mobileProductsToggle.querySelector('[data-lucide="chevron-down"]');
        mobileProductsToggle.addEventListener('click', (e) => {
            e.preventDefault();
            const isHidden = mobileProductsMenu.classList.contains('hidden');
            if (isHidden) {
                mobileProductsMenu.classList.remove('hidden');
                mobileProductsMenu.classList.add('flex');
                if (productsChevron) productsChevron.classList.add('rotate-180');
            } else {
                mobileProductsMenu.classList.remove('flex');
                mobileProductsMenu.classList.add('hidden');
                if (productsChevron) productsChevron.classList.remove('rotate-180');
            }
        });
    }
};

// On phones, data tables are shown as one card per row (header text becomes a label
// beside each value) so nothing needs horizontal scrolling. Desktop keeps the table.
const initResponsiveTables = () => {
    const tables = [...document.querySelectorAll('table')].filter(t => t.tHead && !t.closest('nav, header, footer'));
    if (tables.length === 0) return;

    if (!document.getElementById('stack-table-styles')) {
        const style = document.createElement('style');
        style.id = 'stack-table-styles';
        style.textContent = `
            @media (max-width: 767px) {
                .stack-wrap { overflow: visible !important; border: 0 !important; box-shadow: none !important; border-radius: 0 !important; }
                table.stack-table, table.stack-table tbody, table.stack-table tr, table.stack-table td { display: block; width: 100%; min-width: 0 !important; box-sizing: border-box; }
                table.stack-table thead { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
                table.stack-table tr { margin-bottom: 12px; border: 1px solid #e2e8f0 !important; border-radius: 12px; overflow: hidden; background: #fff !important; box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04); }
                table.stack-table td { display: flex; justify-content: space-between; align-items: baseline; gap: 16px; padding: 9px 14px !important; border: 0 !important; border-top: 1px solid #f1f5f9 !important; text-align: right !important; font-size: 13.5px; line-height: 1.4; color: #334155; }
                table.stack-table td::before { content: attr(data-label); flex: 0 0 auto; max-width: 50%; text-align: left; font-size: 12px; font-weight: 500; color: #94a3b8; }
                table.stack-table td[data-label=""]::before { display: none; }
                table.stack-table td:first-child { display: block; border-top: 0 !important; background: #e1f5fe; text-align: left !important; font-size: 14.5px; font-weight: 600; color: #0f172a; padding: 11px 14px !important; }
                table.stack-table td:first-child::before { display: none; }
                table.stack-table tr.stack-section { margin: 20px 0 8px; border: 0 !important; box-shadow: none; background: transparent !important; }
                table.stack-table tr.stack-section td { background: transparent; padding: 0 2px !important; font-size: 13px; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; color: #248fce; }
                table.stack-table tr.stack-section td::before { display: none; }
            }
        `;
        document.head.appendChild(style);
    }

    tables.forEach(table => {
        // Map header cells onto columns, honouring colspan/rowspan; with grouped headers
        // the lowest (most specific) row wins.
        const labels = [];
        const taken = [];
        [...table.tHead.rows].forEach((row, r) => {
            let col = 0;
            [...row.cells].forEach(cell => {
                while (taken[r] && taken[r][col]) col++;
                const text = cell.textContent.replace(/\s+/g, ' ').trim();
                for (let c = col; c < col + cell.colSpan; c++) {
                    labels[c] = text;
                    for (let rr = r; rr < r + cell.rowSpan; rr++) (taken[rr] = taken[rr] || [])[c] = true;
                }
                col += cell.colSpan;
            });
        });

        [...table.tBodies].forEach(tbody => [...tbody.rows].forEach(row => {
            if (row.cells.length === 1 && row.cells[0].colSpan > 1) {
                row.classList.add('stack-section');
                return;
            }
            let col = 0;
            [...row.cells].forEach(cell => {
                cell.setAttribute('data-label', labels[col] || '');
                col += cell.colSpan;
            });
        }));

        table.classList.add('stack-table');
        if (table.parentElement.classList.contains('overflow-x-auto')) table.parentElement.classList.add('stack-wrap');
    });
};

const initTabs = () => {
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabBtns.length === 0 || tabContents.length === 0) return;

    // Mobile layout for the property tabs and their tables (desktop is unchanged).
    if (!document.getElementById('tab-mobile-styles')) {
        const style = document.createElement('style');
        style.id = 'tab-mobile-styles';
        style.textContent = `
            @media (max-width: 767px) {
                .tab-bar { display: grid !important; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; margin-top: 2.5rem; margin-bottom: 1.5rem !important; overflow: visible !important; padding-bottom: 0 !important; }
                .tab-bar > :not(.tab-btn) { display: none !important; }
                .tab-bar .tab-btn { padding: 10px 8px !important; margin: 0 !important; text-align: center; font-size: 13px; line-height: 1.3; white-space: normal; border: 1px solid #e2e8f0 !important; border-radius: 10px; color: #64748b; background: #fff; }
                .tab-bar .tab-btn.active { background: #248fce; border-color: #248fce !important; color: #fff !important; }
                .tab-bar .tab-btn.tab-span-full { grid-column: 1 / -1; }
            }
        `;
        document.head.appendChild(style);
    }
    const tabBar = tabBtns[0].parentElement;
    tabBar.classList.add('tab-bar');
    if (tabBtns.length % 2 === 1) tabBtns[tabBtns.length - 1].classList.add('tab-span-full');

    tabBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const targetId = btn.id.replace('tab-', 'content-');
            const targetContent = document.getElementById(targetId);
            
            if (!targetContent) return;

            tabBtns.forEach(b => {
                b.classList.remove('border-b-2', 'border-primary', 'text-primary', 'active');
                b.classList.add('text-[#BCC1CF]');
            });

            btn.classList.remove('text-[#BCC1CF]');
            btn.classList.add('border-b-2', 'border-primary', 'text-primary', 'active');

            tabContents.forEach(content => {
                content.classList.add('hidden');
            });

            targetContent.classList.remove('hidden');
        });
    });
};

// Floating "back to top" button, shown once the visitor has scrolled down a bit.
const initBackToTop = () => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Back to top');
    btn.title = 'Back to top';
    btn.className = 'fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 w-11 h-11 md:w-12 md:h-12 rounded-full bg-primary text-white shadow-lg flex items-center justify-center hover:bg-primary-dark transition-all duration-300 opacity-0 translate-y-4 pointer-events-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2';
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m18 15-6-6-6 6"/></svg>';
    document.body.appendChild(btn);

    const toggle = () => {
        const show = window.scrollY > 400;
        btn.classList.toggle('opacity-0', !show);
        btn.classList.toggle('translate-y-4', !show);
        btn.classList.toggle('pointer-events-none', !show);
        btn.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();

    btn.addEventListener('click', () => {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
};

// Contact page form: posts to api/contact.php, which emails the enquiry to the sales inbox.
const initContactForm = () => {
    const form = document.getElementById('contactForm');
    if (!form) return;
    const status = document.getElementById('contact-status');
    const submit = document.getElementById('contact-submit');

    const showStatus = (ok, message) => {
        status.textContent = message;
        status.classList.remove('hidden', 'bg-green-50', 'border-green-200', 'text-green-800', 'bg-red-50', 'border-red-200', 'text-red-700');
        status.classList.add(...(ok ? ['bg-green-50', 'border-green-200', 'text-green-800'] : ['bg-red-50', 'border-red-200', 'text-red-700']));
    };

    form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const name = form.elements.name.value.trim();
        const phone = form.elements.phone.value.trim();
        const email = form.elements.email.value.trim();
        if (!name) { showStatus(false, 'Please enter your name.'); form.elements.name.focus(); return; }
        if (!/^\+?[0-9 ()-]{7,20}$/.test(phone)) { showStatus(false, 'Please enter a valid phone number.'); form.elements.phone.focus(); return; }
        if (!form.elements.email.checkValidity() || !email) { showStatus(false, 'Please enter a valid email address.'); form.elements.email.focus(); return; }

        const data = new FormData(form);
        data.append('page', window.location.pathname);
        submit.disabled = true;
        submit.textContent = 'SENDING...';

        try {
            const response = await fetch('/api/contact.php', { method: 'POST', body: data, credentials: 'same-origin' });
            const result = await response.json().catch(() => ({ ok: false }));
            if (result.ok) {
                form.reset();
                showStatus(true, result.message);
            } else {
                showStatus(false, result.message || 'Sorry, your message could not be sent. Please call us on +91 7200567899.');
            }
        } catch (error) {
            showStatus(false, 'Sorry, your message could not be sent. Please check your connection or call us on +91 7200567899.');
        } finally {
            submit.disabled = false;
            submit.textContent = 'SEND MESSAGE';
        }
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initPageTransitions();
        initCatalogueDownloads();
        initIcons();
        initSwiper();
        initHeaderScroll();
        initMobileMenu();
        initTabs();
        initResponsiveTables();
        initSearch();
        initContactForm();
        initBackToTop();
    });
} else {
    initPageTransitions();
    initCatalogueDownloads();
    initIcons();
    initSwiper();
    initHeaderScroll();
    initMobileMenu();
    initTabs();
    initResponsiveTables();
    initSearch();
    initContactForm();
    initBackToTop();
}
